<template>
  <div class="register">
    <!-- 登录标题 -->
    <div class="loginTitle">
      <div class="w">
        <div class="loginTitle-logo fl">
          <img src="https://www.myfund.com/images/zhx_logo.png" alt="" class="logo">
        </div>
        <div class="loginTitle-phone fr">
          <p>咨询热线：<span>400-818-8000</span> </p>
        </div>
      </div>
    </div>
    <div class="register_con w common-box" style="height:599px;">
      <el-row class="row-one">
        <span class="row-one-title">密码重置 </span>
      </el-row>
      <el-form v-show="stepDisplay == '1'" :model="formOne" :rules="formOneRules" ref="formOneRef" label-width="106px" label-position="right" class="form-single">
        <el-form-item label="证件类型：" class="margin-t70">
          <el-input v-model="formOne.type" placeholder="请输入身份证号" disabled></el-input>
        </el-form-item>
        <el-form-item label="身份证号：" prop="id">
          <el-input v-model="formOne.id" placeholder="请输入身份证号"></el-input>
        </el-form-item>
        <el-form-item label="姓名：" prop="username">
          <el-input v-model="formOne.username" placeholder="请输入真实姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号：" prop="phone">
          <el-input v-model="formOne.phone" placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item label="手机验证码：" prop="code" :error="codeError">
          <el-input v-model="formOne.code" placeholder="请输入手机验证码" style="border-radius:3px 0 0 3px;">
            <el-button type="code" :disabled="codeDisable" slot="append" @click="getCode">
              <span v-show="sendAuthCode">{{this.codefont == '0'? '获取验证码':'重新获取'}}</span>
              <span v-show="!sendAuthCode">{{auth_time}} 秒</span>
            </el-button>
          </el-input>
        </el-form-item>
        <el-form-item>
          <div class="margin-t20">
            <el-button type="normal" @click="nextOne">下一步</el-button>
            <el-button type="cancel" class="fr" @click="$router.push({name:'login'})" style="margin-left: 9px;">返回</el-button>
          </div>
        </el-form-item>
      </el-form>
      <el-form v-show="stepDisplay == '2'" :model="formTwo" :rules="formTwoRules" ref="formTwoRef" label-width="100px" label-position="right" class="form-single">
        <el-form-item>
          <el-input v-model="formTwo.name" placeholder="请输入身份证号" style="display:none;"></el-input>
        </el-form-item>
        <el-form-item label="交易密码：" style="margin-top:150px;" prop="newPass">
          <el-input type="password" v-model="formTwo.newPass" placeholder="请输入您的交易密码" @input="formTwo.newPass = formTwo.newPass.trim()" autoComplete="new-password" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码：" prop="confirePass">
          <el-input type="password" v-model="formTwo.confirePass" placeholder="请再次输入交易密码" @input="formTwo.confirePass = formTwo.confirePass.trim()" autoComplete="new-password" show-password></el-input>
        </el-form-item>
        <el-form-item>
          <div class="el-form-item__error warnColor" style="width:350px;line-height: 20px;">注：密码长度为6-8位，不能含有3个及以上重复相同、连续数字或字母、空格或者汉字</div>
        </el-form-item>
        <el-form-item>
          <div class="margin-t50">
            <el-button type="normal" @click="nextTwo">下一步</el-button>
            <el-button type="cancel" class="fr" @click="stepDisplay = '1'">返回</el-button>
          </div>
        </el-form-item>
      </el-form>
      <!-- 密码修改成功弹框 -->
      <el-dialog class="dialog-single-one" center :visible.sync="dialogVisable" :show-close="false" :close-on-click-modal="false">
        <img src="../../assets/images/2021_dg.png" alt="" width="60">
        <p class="dialog-single-one-p" style="padding: 0px 48px;">修改密码成功！<br />展恒基金网欢迎您，祝您体验愉快~~</p>
        <span slot="footer" class="dialog-footer">
          <el-button type="normal1" @click="$router.push({name:'login'})">登录账号</el-button>
          <el-button type="normal1" @click="indexClick">去首页</el-button>
        </span>
      </el-dialog>
    </div>
    <lvFooter></lvFooter>
  </div>
</template>

<script>
import lvFooter from '../../components/lv-footer/lv-footer.vue';
export default {
  name: "forgetPass",
  components: {
    lvFooter
  },
  data () {
    var validateId = (rule, value, callback) => {
      var isIDCard = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
      if (!isIDCard.test(value)) {
        callback(new Error('请输入正确的身份证号'));
      } else {
        callback();
      }
    };
    var validateName = (rule, value, callback) => {
      var name = /^[\u4e00-\u9fa5]+$/;
      if (value.length == 1 || value.length > 4 || !name.test(value)) {
        callback(new Error('请输入正确的姓名'));
      } else {
        callback();
      }
    };
    var validateNum = (rule, value, callback) => {
      const cell = /^(13|15|16|17|18|14|19)\d{9}$/g;
      if (!cell.test(value)) {
        callback(new Error('输入的手机号码格式不正确'));
      } else {
        callback();
      }
    };
    var validatePass1 = (rule, value, callback) => {
      var req = /(\w)\1{2}/;
      var reString = /^[\u4E00-\u9FA5]+$/;
      if (value.search(req) != -1) {
        callback(new Error('密码内不能含有3个连续相同的字符！'));
      } else if (!this.$commonJs.checkSeries(value)) {
        callback(new Error('密码不能有三个以上(含三个)的连续数字或字母！'));
      } else if (reString.test(value)) {
        callback(new Error('密码不能有汉字！'));
      } else {
        if (this.formTwo.confirePass !== '') {
          this.$refs.formTwoRef.validateField('confirePass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value !== this.formTwo.newPass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      formOne: {
        type: '身份证',
        id: '',
        username: '',
        phone: '',
        code: '',
      },
      formOneRules: {
        id: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { validator: validateId, trigger: 'blur' }
        ],
        username: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' },
          { validator: validateName, trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { validator: validateNum, trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入手机验证码', trigger: 'blur' },
          { min: 6, max: 6, message: '请输入六位短信验证码', trigger: 'blur' }
        ],
      },
      formTwo: {
        name: '',
        newPass: '',
        confirePass: ''
      },
      formTwoRules: {
        newPass: [
          { required: true, message: '请输入新的交易密码', trigger: 'blur' },
          { min: 6, max: 8, message: '密码位数必须为6～8位！', trigger: 'blur' },
          { validator: validatePass1, trigger: 'blur' }
        ],
        confirePass: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { min: 6, max: 8, message: '密码位数必须为6～8位！', trigger: 'blur' },
          { validator: validatePass2, trigger: 'blur' }
        ],
      },
      stepDisplay: '1',
      dialogVisable: false,
      codeError: '',
      // 验证码
      auth_time: 0,
      codeDisable: false,
      sendAuthCode: true,
      codefont: 0,
    }
  },
  methods: {
    indexClick () {
      window.open('https://www.myfund.com/', '_blank')
    },
    getCode () {
      if (this.formOne.id == '' || this.formOne.username == '' || this.formOne.phone == '') {
        this.codeError = '请完善以上绑卡信息再尝试获取验证码'
      } else {
        this.codeError = ''
        this.$http.post(this.$apiPath.checkInfo, {
          certificatetype: '0',
          certificateno: this.formOne.id,
          custname: this.formOne.username,
          mobileno: this.formOne.phone,
        }).then(res => {
          if (res.data.code == "200" && res.data.success) {
            this.sendMsg()
          } else {
            this.$message.error(res.data.message)
          }
        }).catch(err => { })
      }
    },
    sendMsg () {
      this.$http.post(this.$apiPath.smsMessageSend, {
        phoneNum: this.formOne.phone,
        flag: "5"
      }).then(res => {
        if (res.data.code == "200" && res.data.success) {
          if (res.data.data.code == "1111") {
            const code = res.data.data.verifyCode
            var exp = new Date();
            exp.setTime(exp.getTime() + 2 * 60 * 1000);
            document.cookie = "notecode=" + code + ";path=/;expires=" + exp.toGMTString();
            this.counter()
          } else {
            this.$message.error('验证码获取失败')
          }
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(err => { })
    },
    counter () {
      this.codeDisable = true
      this.sendAuthCode = false;
      this.auth_time = 120;
      var auth_timetimer = setInterval(() => {
        if (this.auth_time == 0) {
          this.sendAuthCode = true;
          this.codeDisable = false
          clearInterval(auth_timetimer);
          this.codefont = 1
        } else {
          this.codefont = 0
          this.auth_time--;
        }
      }, 1000);
    },
    nextOne () {
      this.$refs.formOneRef.validate(valid => {
        if (!valid) return
        this.codeError = ''
        if (!this.codefont == "1") {
          if (this.formOne.code != '' && this.formOne.code == this.$commonJs.getCookie('notecode')) {
            this.stepDisplay = '2'
          } else {
            this.$nextTick(() => {
              this.codeError = '验证码输入错误！'
            })
          }
        } else {
          this.codeError = '验证码已失效，请重新获取验证码！'
        }
      })

    },
    nextTwo () {
      this.$refs.formTwoRef.validate(valid => {
        if (!valid) return
        this.$http.post(this.$apiPath.resetTPassword, {
          certificateno: this.formOne.id,//证件号码
          accttype: '',
          certificatetype: '0',
          newpwd: this.$des.enString(this.formTwo.newPass, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3)
        }).then(res => {
          // console.log(res);
          if (res.data.code == "200" && res.data.success) {
            this.dialogVisable = true
          } else {
            this.$message.error('密码修改失败')
          }
        }).catch(err => { })
      })
    },
  }
}
</script>

<style lang="less" scoped>
</style>